<template>
  <el-card class="detail-card" shadow="never">
    <div slot="header" class="card-header">
      <span class="card-title"><i class="el-icon-office-building"></i> 企业介绍信息</span>
    </div>
    <div class="company-block">
      <div class="company-name">{{ companyInfo.companyName || '—' }}</div>
      <el-divider class="compact-divider"></el-divider>
      <div class="info-row">
        <span class="info-label">统一社会信用代码</span>
        <span class="info-value">{{ companyInfo.creditCode || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">法定代表人</span>
        <span class="info-value">{{ companyInfo.legalPerson || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">注册资本</span>
        <span class="info-value">{{ companyInfo.registerCapital || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">成立日期</span>
        <span class="info-value">{{ companyInfo.establishDate || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">企业类型</span>
        <span class="info-value">{{ companyInfo.companyType || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">经营状态</span>
        <span class="info-value">{{ companyInfo.status || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">注册地址</span>
        <span class="info-value">{{ companyInfo.registerAddress || '—' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">经营范围</span>
        <span class="info-value text-wrap">{{ companyInfo.businessScope || '—' }}</span>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'CompanyInfoCard',
  props: {
    // 企业信息，由父组件请求 project/Detail 后传入（enterpriseInfo）
    enterpriseInfo: { type: Object, default: () => ({}) }
  },
  computed: {
    // enterpriseInfo 字段 -> 模板字段映射
    companyInfo() {
      const info = this.enterpriseInfo || {}
      return {
        companyName: info.enterprise_name || '',
        creditCode: info.usc_code || '',
        legalPerson: info.legal_person_name || '',
        registerCapital: info.register_amount ? info.register_amount + '万' + (info.currency_kind_name || '') : '',
        establishDate: (info.found_date || '').substring(0, 10),
        companyType: info.economic_type_name || '',
        status: info.corporation_status_name || '',
        registerAddress: info.register_address || '',
        businessScope: info.corporation_scope || ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 卡片统一样式 */
.detail-card {
  border-radius: 8px;
  border: 1px solid #ebeef5;
  ::v-deep .el-card__header {
    padding: 14px 20px;
    border-bottom: 1px solid #ebeef5;
    background: #fafbfc;
  }
  ::v-deep .el-card__body {
    padding: 20px;
  }
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  i {
    margin-right: 6px;
    color: #409eff;
  }
}

/* 企业信息 */
.company-block {
  .company-name {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
  .company-sub {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
  }
}
.compact-divider {
  margin: 12px 0;
}
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  &:last-child {
    border-bottom: none;
  }
  .info-label {
    color: #909399;
    flex-shrink: 0;
    margin-right: 12px;
    min-width: 100px;
  }
  .info-value {
    color: #606266;
    text-align: right;
    word-break: break-all;
    &.text-wrap {
      text-align: left;
      line-height: 1.6;
    }
  }
}
</style>